<template>

    <article class="ArticleTextColumns" v-if="ready">
        <div class="ArticleTextColumns__scollarea">
            <div class="ArticleTextColumns__chapter" v-for="chapter in properties.chapters">
                <h3>{{ chapter.title }}</h3>
                <div class="columned" v-html="chapter.text"></div>
            </div>
        </div>
    </article>

</template>

<script>




export default {
    props: ["properties"],
    data() {
        return {
            ready: false,

        }
    },
    mounted() {
        console.log(this.properties);
        this.ready = true;

    },
    methods: {

        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },
        getMediaPath(mediaUrl) {
            return app.api.Utils.getMediaPath(mediaUrl)
        },

    },
    computed: {

    }
};

</script>


<style lang="scss">
.ArticleTextColumns {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 55px 55px;
  

    &__scollarea {
        overflow: auto;
        width: 100%;
        height: 100%;
        padding-right: 55px;
    }

    &__chapter {
        border-bottom: 1px solid var(--main-color);
        margin-bottom: 3em;
        padding-bottom: 2em;
        text-align: left;

        &:last-of-type {
            border:none;
            margin-bottom: 0;
        }

        .columned {
            height: fit-content;
            text-align: left;
            column-gap: 60px;
            column-count: 3;
            column-fill: balance;
        }

    }

}
</style>